import { useAppScopeStore } from '@frontend/scope';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

export const useIsRequestTabEnabled = ({ locationIds: locationIdsProp }: { locationIds?: string[] } = {}) => {
  const { getCFLocationMap } = useSchedulingLocationInfo();
  const { selectedLocationIds } = useAppScopeStore();
  const locationIds = locationIdsProp ?? selectedLocationIds;

  const onlineSchedulingCFLocationMap = getCFLocationMap('onlinescheduling');
  const filteredCFLocationIds = Object.keys(onlineSchedulingCFLocationMap).filter((locationId) =>
    locationIds.includes(locationId)
  );
  const enabledLocationIds = filteredCFLocationIds.filter(
    (locationId) => !!onlineSchedulingCFLocationMap?.[locationId]
  );
  const isRequestTabEnabled = enabledLocationIds.length > 0;

  return { isRequestTabEnabled, enabledLocationIds };
};
